import { EntitySelectorsFactory } from "@ngrx/data";
import { Dictionary } from "@ngrx/entity";
import { createSelector } from "@ngrx/store";
import { selectMlid } from "./shared.selectors";
import { ListingSummary } from "./shared/interfaces/listing-summary";

export const listingSummarySelectors = new EntitySelectorsFactory().create<ListingSummary>(
	"ListingSummary"
);

const selectListingSummaryByListingIdFn =
	(listingId: string) =>
	(listingSummaryMap: Dictionary<ListingSummary>): ListingSummary | undefined =>
		listingSummaryMap[listingId] || undefined;

export const selectListingSummaryByListingId = (listingId: string) =>
	createSelector(
		listingSummarySelectors.selectEntityMap,
		selectListingSummaryByListingIdFn(listingId)
	);

export const selectListingSummary = createSelector(
	selectMlid,
	listingSummarySelectors.selectEntityMap,
	(listingId, listingSummaryMap) => selectListingSummaryByListingIdFn(listingId)(listingSummaryMap)
);

export const selectListingSkFn = (listingSummary?: ListingSummary) => listingSummary?.listingSK;

export const selectListingSKByListingId = (listingId: string) =>
	createSelector(selectListingSummaryByListingId(listingId), selectListingSkFn);

export const selectListingSK = createSelector(selectListingSummary, selectListingSkFn);
